import { useDispatch, useSelector } from "react-redux"
import { clearProposalId, clearTypeModal, clearTypeOfProposalStatus, clearUpdateTypeModal } from "../../features/gms-state-and-modal/modal-slice"
import { selectedRequestAmendment, selectNotesReason, selectOldProposalData, setAmendmentModal, setAmendmentModalOne, setHasProposedData, setNotesReason, setOldProposalData, setSelectedRequestAmendment } from "../../features/actuarial/request-amendment/request-amendment.slice"
import { getErrorMessage } from "../../utils/get-error-message.utils"
import { useToastify } from "../../library/toastify/toast-provider"
import { useCreateProposalForm } from "./use-create-proposal-form"
import { selectFiles } from "../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice"
import { SupportingDocumentFile } from "../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.state"
import { getChangedParentFields } from "../../utils/get-changed-proposal"
import { useAcceptRequestAmendmentMutation, useCreateRequestAmendmentMutation, useDeclineRequestAmendmentMutation } from "../../api/request-amendment/request-amendment-api"
import { setCurrentStep } from "../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice"
import { resetProposalForm } from "../../helper/proposal/proposal-reset-form"
import { useModalAccess } from "../../components/global/modal/use-modal-access"

export const useRequestAmendment = () => {

    const { showToastNotify } = useToastify();
    const dispatch = useDispatch();
    const { currentProposalId } = useModalAccess();
    // const { requestAmendment, declineRequestAmendment, acceptRequestAmendment } = useMutation();
    const [requestAmendment, { isLoading: isLoadingRequestAmendment }] = useCreateRequestAmendmentMutation()
    const [declineRequestAmendment, { isLoading: isLoadingDeclineRequestAmendment }] = useDeclineRequestAmendmentMutation()
    const [acceptRequestAmendment, { isLoading: isLoadingAcceptRequestAmendment }] = useAcceptRequestAmendmentMutation()
    const reasonNotes = useSelector(selectNotesReason);
    const requestAmendmentData = useSelector(selectedRequestAmendment);
    const requestAmendmentApplicationId = requestAmendmentData?.application_id;
    const { proposalData } = useCreateProposalForm();
    const originalProposal = useSelector(selectOldProposalData);
    const files = useSelector(selectFiles);
    const hasProposedData = useSelector(setHasProposedData)

const changedFields = getChangedParentFields(originalProposal, proposalData);

const updatedFields = changedFields
    ? {
        ...changedFields,
        ...(Array.isArray(changedFields.company_contact_info) && changedFields.company_contact_info.length > 0
            ? {
                company_contact_info: changedFields.company_contact_info.map((item) => ({
                    company_contact_number_type_id: item.company_contact_number_type_id,
                    company_contact_number: item.company_contact_number,
                })),
            }
            : {}),
        ...(Array.isArray(changedFields.contact_number_info) && changedFields.contact_number_info.length > 0
            ? {
                contact_number_info: changedFields.contact_number_info.map((item) => ({
                    contact_person_number_type_id: item.company_contact_number_type_id,
                    contact_person_number: item.company_contact_number,
                })),
            }
            : {}),
    } : {};

    const finalUpdatedFields =
        Object.keys(updatedFields).length > 0
            ? updatedFields
            : null;

    const newFile = files.find((item): item is SupportingDocumentFile & { file: File } => item.type === "new" && item.file != null)?.file ?? null;

    const handleRequestAmendment = async () => {
        
        if(!currentProposalId) return
        try {
            const response = await requestAmendment({
                proposalId: currentProposalId,
                request_notes: reasonNotes,
                proposed_data: hasProposedData ? finalUpdatedFields : null,
                file: hasProposedData ? newFile : null,
            }).unwrap()

            showToastNotify(response.message, 'success')

            dispatch(setAmendmentModalOne(null))
            dispatch(setNotesReason(''))
            dispatch(setOldProposalData(null))

            dispatch(clearUpdateTypeModal());
            dispatch(clearProposalId());
            dispatch(clearTypeOfProposalStatus());
            dispatch(clearTypeModal());
            dispatch(setCurrentStep(1));
            resetProposalForm(dispatch);
        } catch (error: any) {
            const errorMsg1 = error?.message
            const errorMsg2 = getErrorMessage(errorMsg1);
            const fileErrorMsg = errorMsg1 || errorMsg2
            showToastNotify(fileErrorMsg, 'error')
        }
    }

    const handleAccentRequestAmendment = async () => {
        if(!requestAmendmentApplicationId) return
        try {
            const response = await acceptRequestAmendment({proposalId: requestAmendmentApplicationId}).unwrap()
            dispatch(setAmendmentModalOne(null))
            dispatch(setAmendmentModal(null))
            dispatch(setSelectedRequestAmendment(null))
            showToastNotify(response.message, 'success')
        } catch (error: any) {
            const errorMsg1 = error?.message
            const errorMsg2 = getErrorMessage(errorMsg1);
            const fileErrorMsg = errorMsg1 || errorMsg2
            showToastNotify(fileErrorMsg, 'error')
        }
    }

    const handleDeclineRequestAmendment = async () => {
        if(!requestAmendmentApplicationId) return
        try {
            const response = await declineRequestAmendment({proposalId: requestAmendmentApplicationId, response_notes: reasonNotes }).unwrap()
            dispatch(setAmendmentModalOne(null))
            dispatch(setAmendmentModal(null))
            dispatch(setSelectedRequestAmendment(null))
            showToastNotify(response.message, 'success')
        } catch (error: any) {
            const errorMsg1 = error?.message
            const errorMsg2 = getErrorMessage(errorMsg1);
            const fileErrorMsg = errorMsg1 || errorMsg2
            showToastNotify(fileErrorMsg, 'error')
        }
    }

    return {
        handleRequestAmendment,
        handleAccentRequestAmendment,
        handleDeclineRequestAmendment,

        isLoadingRequestAmendment,
        isLoadingDeclineRequestAmendment,
        isLoadingAcceptRequestAmendment,
    }
}